import { getUrlParam } from 'core-components/helpers/url'

import { ProgramTypes } from '../../../../classes/models/ProgramTypes'

export const getUrlProgramType = () => {
  const urlProgramType = getUrlParam('ptype')
  if (!urlProgramType) {
    return ProgramTypes.None
  }

  return urlProgramType as ProgramTypes
}
